module.exports = "/images/dx-icon.svg?a2d74c94b51bdc21db52bc5efea1c5c8";


//////////////////
// WEBPACK FOOTER
// ./resources/images/speedtest-result/dx-icon.svg
// module id = DKXQ
// module chunks = 7 183